import React, { useState, useContext } from 'react';
import {Text, LegacyStack, Link, Modal} from '@shopify/polaris';
import { ExtensionsContext } from '../../contexts/Extensions'
import { SellingPlansContext } from '../../contexts/SellingPlans'
import {useReducerModal} from '@thinkwell/react.common'

export default function AddExtension(props) {
  const sellingPlans = useContext(SellingPlansContext)
  const [extensions] = useContext(ExtensionsContext)
  const [state, onActive] = useReducerModal(props, props.active);

  const sellingPlanByVariantId = sellingPlans.reduce((sellingPlanByVariantId, sellingPlan) => {
    sellingPlanByVariantId[sellingPlan.variantId] = sellingPlan
    return sellingPlanByVariantId;
  }, {})
  const extensionsRecur = extensions.filter((extension) => !!sellingPlanByVariantId[extension.variant_id])

  return (extensionsRecur.length > 0 ? <div className={state.active ? 'open' : 'closed'}>
      <Link onClick={() => onActive(true)}>Buy Extension</Link>
      <Modal
        open={state.active}
        onClose={() => onActive(false)}
        title="Buy Extension"
      >
        <Modal.Section>
        <table><tbody>
          {
            extensionsRecur.map((extensionRecur) => {
              const sellingPlan = extensionRecur && sellingPlanByVariantId[extensionRecur.variant_id]
              const extensionPrice = `$${(sellingPlan && sellingPlan.price) || extensionRecur.price}`
              return (<tr key={extensionRecur.variant_id}>
                <td>
                  <p dangerouslySetInnerHTML={{__html: extensionRecur.body_html || extensionRecur.title}}></p>
                  <span className="Polaris-TextStyle--variationStrong" data-text={extensionPrice}>{extensionPrice}</span>
                  <form id="registration-form" action="/cart/add" method="post">
                    <input type="hidden" name="properties[_subscription]" value={`${sellingPlan.id}-${Date.now()}`} />
                    <input type="hidden" name="properties[_enrollment_to_extend]" value={props.enrollment_id} />
                    <input type="hidden" name="selling_plan" value={sellingPlan.id} />
                    <input type="hidden" name="id" value={extensionRecur.variant_id} />
                    <input type="hidden" name="properties[Course]" value={props.course_name} />
                    <input type="submit" className="button" value="Buy Extension" />
                  </form>
                </td>
              </tr>)
            })
          }
        </tbody></table>
        </Modal.Section>
      </Modal>
    </div> : null)
}
